<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
  }

  const ctx: BaseProps = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  }

  export let size: BaseProps['size'] = ctx.size || 'md'
  export let role: BaseProps['role'] = ctx.role || 'img'
  export let ariaLabel = 'Web novel'
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  viewBox="0 0 32 32"
>
  <rect width="32" height="32" rx="6" fill="#5b6abf" />
  <path
    fill="#fff"
    d="M8 9h16v2H8zm0 4h16v2H8zm0 4h10v2H8zm0 4h14v2H8z"
  />
</svg>
